import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'inspectionstatus',
    standalone: false
})
export class InspectionStatusPipe implements PipeTransform {
  transform(value: number): any {
    switch (value) {
      case 0:
        return 'New';
      case 100:
        return 'Published';
      case 150:
        return 'Scheduled';
      case 200:
        return 'In progress';
      case 250:
        return 'Preview'; // old 'Done'
      case 300:
        return 'Reviewed'; // not used anymore (kept for old inspections)
      case 350:
        return 'Released';
      case -100:
        return 'Cancelled';
      case -10:
        return 'Deleted';
      case -200:
        return 'Archived';
      default:
        return '';
    }
  }
}
